// src/main.js (PARA LA APLICACIÓN DEL PERSONAL O DEL PACIENTE)

import { createApp } from 'vue';
import App from './App.vue';

// --- Importaciones de Firebase ---
import { initializeApp } from 'firebase/app';
import { getPerformance, trace } from 'firebase/performance';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check'; // ¡Importaciones de App Check!


// ======================================================================================
// !!! IMPORTANTE: TU CONFIGURACIÓN DE FIREBASE PARA ESTA APP ESPECÍFICA !!!
// Asegúrate de que estos valores sean los CORRECTOS para la APP actual (paciente o personal).
// Encuentra esta configuración en la Consola de Firebase > Configuración del proyecto > Tus apps > "Configuración"
// ======================================================================================
const firebaseConfig = {
apiKey: "AIzaSyD09zdY2XQTSOPw1h0CSULpVgC4YIOjPSs",
  authDomain: "clinicajure.firebaseapp.com",
  projectId: "clinicajure",
  storageBucket: "clinicajure.firebasestorage.app",
  messagingSenderId: "944673196450",
  appId: "1:944673196450:web:c267c9cfbe27a559380afb",
  measurementId: "G-RKJKX3ZENF"
};

// Inicializa Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Inicializa Firebase Performance Monitoring
const perf = getPerformance(firebaseApp);

// --- Inicializa Firebase App Check ---
// Asegúrate de usar la CLAVE DEL SITIO de reCAPTCHA v3 correcta para ESTA aplicación.
// La clave del sitio es la que generaste en la consola de Google reCAPTCHA.
// NO es la clave secreta.
// También es crucial que el dominio de tu app (ej. personal.centrodelavisionjure.com y localhost)
// esté configurado en la consola de Google reCAPTCHA para esta clave.
initializeAppCheck(firebaseApp, {
  provider: new ReCaptchaV3Provider('6LddBRosAAAAAB8pmwNLGhyupDiLqJGdYBM9MwBN'), // <-- ¡Pega la CLAVE DEL SITIO de reCAPTCHA v3 para ESTA APP!
  isTokenAutoRefreshEnabled: true // Habilita la actualización automática del token. ¡Muy importante!
});


// Monitoreo básico de errores de JavaScript (simulando Crashlytics para web)
window.onerror = function(message, source, lineno, colno, error) {
  console.error("Error global capturado:", message, source, lineno, colno);

  // Incluimos el stack trace del error si está disponible
  if (error && error.stack) {
    console.error("Stack trace:", error.stack);
  }
  return true; // Para suprimir la visualización predeterminada del error en la consola del navegador
};

// ======================================================================================
// Traza personalizada de carga de la aplicación (para Firebase Performance Monitoring)
// Esto enviará una métrica de cuánto tarda tu app en montarse.
// ======================================================================================
const appStartTrace = trace(perf, 'app_start_trace');
appStartTrace.start();

const app = createApp(App);

// Si tienes Vue Router, la inicialización iría aquí, antes del mount
// app.use(router); // Ejemplo si usas Vue Router

app.mount('#app');

// Detiene la traza al montar la app, enviando los datos a Performance Monitoring
appStartTrace.stop();
